import moment from 'moment'
import { ConceptModel, ProductConceptModel } from '../../../../../api/Argentia/model/contracts'
import { generateUniqueKey, generateUniqueKeyWithNoPrefix } from '../../../../../helpers'
import { associateActionIcon } from '../../../../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../../../../model'
import { EnumTipoRelacionProductoConcepto } from '../../../../../api/oData/enums/enumTipoRelacionProductoConcepto'
import { EnumTipoCondicionConcepto } from '../../../../../api'

export const mapConceptsResponse = (concepts: any[]): ConceptModel[] => {
  return concepts.map(concept => mapConceptResponse(concept))
}

export const mapConceptResponse = (concept: any): ConceptModel => {
  return {
    conceptId: concept.id,
    code: concept.code,
    description: concept.description,
    conceptType: concept.conceptType,
    calculationType: concept.calculationType,
    quantityType: concept.quantityType
  }
}

export const onAddMapConceptModelToProductConceptModel = (
  concepts: ConceptModel[],
  filterByRelationType: EnumTipoRelacionProductoConcepto,
  conditionType?: EnumTipoCondicionConcepto | null
): ProductConceptModel[] => {
  return concepts.map(concept => {
    return {
      conceptId: concept.conceptId,
      code: concept.code,
      description: concept.description,
      conceptType: concept.conceptType,
      calculationType: concept.calculationType,
      quantityType: concept.quantityType,
      startDate: moment().month(0).date(1).toDate(),
      endDate: null,
      tempId: generateUniqueKeyWithNoPrefix(),
      actions: associateActionIcon(concept, ActionIcons.NEW_ITEM, 'No Guardado'),
      conceptNotFromApiGet: true,
      // required: isObligatory,
      relationType: filterByRelationType,
      conditionType: conditionType
    }
  })
}

export const onEditMapConceptModelToProductConceptModel = (
  concept: ProductConceptModel
): ProductConceptModel => {
  return {
    id: concept.id,
    conceptId: concept.conceptId,
    code: concept.code,
    description: concept.description,
    conceptType: concept.conceptType,
    calculationType: concept.calculationType,
    quantityType: concept.quantityType,
    startDate: concept.startDate,
    endDate: concept.endDate,
    tempId: concept.tempId ? concept.tempId : generateUniqueKeyWithNoPrefix(),
    actions: concept.actions
      ? concept.actions
      : associateActionIcon(concept, ActionIcons.NEW_ITEM, 'No Guardado'),
    conceptNotFromApiGet: concept.conceptNotFromApiGet,
    required: concept.required,
    relationType: concept.relationType,
    conditionType: concept.conditionType
  }
}
